 
import React from "react";
import { Link } from "react-router-dom";
import arrowLeftWhite from "../../assets/images/svg2/arrow-left-white.svg";
import arrowRightWhite from "../../assets/images/svg2/arrow-right-white.svg";

export default function PostNavigation() {
	return (
		<div className="fugu--post-navigation-wrap">
			<Link to={"#"}>
				<div className="fugu--post-navigation nav-previous">
					<div className="fugu--post-navigation-icon">
						<img src={arrowLeftWhite} alt="" />
					</div>
					<div className="fugu--post-navigation-data">
						<p>Previous post</p>
						<span>What does the NFT Ecosystem look like after the Boom?</span>
					</div>
				</div>
			</Link>
			<Link to={"#"}>
				<div className="fugu--post-navigation nav-next">
					<div className="fugu--post-navigation-data">
						<p>Next post</p>
						<span>Metaverse Launch: Let’s take a step back with data!</span>
					</div>
					<div className="fugu--post-navigation-icon">
						<img src={arrowRightWhite} alt="" />
					</div>
				</div>
			</Link>
		</div>
	);
}
